var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPeople = function SvgPeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60004 17.2V2.8C3.60004 2.3584 3.95844 2 4.40004 2H14C15.3256 2 16.4 3.0744 16.4 4.4V15.6C16.4 16.9256 15.3256 18 14 18H4.40004C3.95844 18 3.60004 17.6416 3.60004 17.2Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C11.3255 10 12.4 8.9255 12.4 7.60001C12.4 6.27453 11.3255 5.20001 10 5.20001C8.67455 5.20001 7.60004 6.27453 7.60004 7.60001C7.60004 8.9255 8.67455 10 10 10Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 11.6H7.6C6.716 11.6 6 12.316 6 13.2C6 14.084 6.716 14.8 7.6 14.8H12.4C13.284 14.8 14 14.084 14 13.2C14 12.316 13.284 11.6 12.4 11.6Z",
    fill: "#C5C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 12.4C3.4768 12.4 3.3544 12.4 3.2 12.4C2.5376 12.4 2 12.9376 2 13.6C2 14.2624 2.5376 14.8 3.2 14.8C3.3544 14.8 3.4768 14.8 3.6 14.8V12.4Z",
    fill: "#C5C5CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 5.20001C3.4768 5.20001 3.3544 5.20001 3.2 5.20001C2.5376 5.20001 2 5.73761 2 6.40001C2 7.06241 2.5376 7.60001 3.2 7.60001C3.3544 7.60001 3.4768 7.60001 3.6 7.60001V5.20001Z",
    fill: "#C5C5CA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "people.3e82587a26e3b9f21cb7ba88a0c536d8.svg";